var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "diglog-card",
      attrs: {
        title: _vm.$t("acceptPayments.create_static_qr"),
        "close-on-click-modal": false,
        visible: _vm.dialogVisible,
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.initData,
      },
    },
    [
      _c("div", { staticClass: "header-line" }),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form-contaniner",
          attrs: {
            model: _vm.form,
            "label-width": "90px",
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("system.remark"), prop: "remark" } },
            [
              _c("el-input", {
                staticClass: "search-frame",
                attrs: {
                  size: "small",
                  maxlength: "200",
                  type: "textarea",
                  placeholder: _vm.$t("acceptPayments.enter_remark"),
                  autocomplete: "off",
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("acceptPayments.tag"), prop: "tag" } },
            [
              _c("el-input", {
                staticClass: "search-frame",
                attrs: {
                  size: "small",
                  maxlength: "25",
                  placeholder: _vm.$t("acceptPayments.enter_tag"),
                  autocomplete: "off",
                  clearable: "",
                },
                model: {
                  value: _vm.form.tag,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "tag", $$v)
                  },
                  expression: "form.tag",
                },
              }),
            ],
            1
          ),
          _c("p", [_vm._v(_vm._s(_vm.$t("tips.create_static_qr_tips")))]),
          _c("p", { staticStyle: { color: "#ccc" } }, [
            _vm._v(_vm._s(_vm.$t("acceptPayments.example"))),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-top": "20px",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "300px", position: "relative" } },
                [
                  _c("div", {
                    staticClass: "merchant-name",
                    domProps: { innerHTML: _vm._s(_vm.qrStandName) },
                  }),
                  _c("img", {
                    staticClass: "qr-stand-bg",
                    attrs: { src: require("@/assets/img/qr_stand_bg.png") },
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info", disabled: _vm.listLoading },
              on: {
                click: function ($event) {
                  return _vm.onSubmit("form")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("components.submit")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }